import { createLeadOrder } from '@/API/repositories/leadOrder';
import { Colors } from '@/common/colors/colors';
import Input from '@/common/components/Input';
import Loading from '@/common/components/Loading';
import PopUp from '@/common/components/PopUp';
import SelectInput from '@/common/components/SelectInput';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useRef, useState } from 'react';

const AddLeadOrderPopup = ({ setShow, onCreated, selectedQueue }) => {
	const {
		options: { queuesOptions },
	} = useCommonDataContext();
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();
	const { addMessage } = useMessageQueueContext();
	const quantityRef = useRef();
	const [queue, setQueue] = useState(selectedQueue);

	const activeQueues = queuesOptions.filter(
		(option) => option.value?.is_in_use === true,
	);

	const handleSubmit = async (event) => {
		event.preventDefault();

		const queueId = queue?.value?._id;
		const hasMissingFields = !queueId || !quantityRef.current.value;

		if (hasMissingFields) {
			addMessage('Fill all fields', 'error');
			return;
		}

		const payload = {
			quantity: Number(quantityRef.current.value),
			queue: queueId,
		};

		const response = await makeRequest(createLeadOrder.bind(null, payload));

		if (!response?.data) {
			addMessage('Something went wrong', 'error');
			return;
		}

		addMessage('Saved', 'success');
		setShow(false);
		onCreated();
	};

	const isSaving = hasUnfilledRequest(createLeadOrder);

	return (
		<PopUp padding='10px 20px 16px' setShow={setShow}>
			{isSaving && <Loading />}
			<h3 style={{ color: Colors.darkBlue, margin: '0 0 12px' }}>
				Add lead order
			</h3>
			<form onSubmit={handleSubmit}>
				<SelectInput
					color={Colors.darkBlue}
					name='Queue'
					options={activeQueues}
					width={220}
					setSelected={setQueue}
					selected={queue}
					required
				/>
				<Input
					inputRef={quantityRef}
					name='Quantity'
					type='number'
					min={1}
					color={Colors.darkBlue}
					width={220}
					required
					requiredSign
				/>
				<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
					<SubmitButton text='Save' />
				</div>
			</form>
		</PopUp>
	);
};

export default AddLeadOrderPopup;
